import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Flower2, Activity, Flame, Droplets, Dumbbell, Baby } from 'lucide-react';
const services = [{
  icon: <Flower2 className="w-8 h-8" data-id="element-188" />,
  title: 'Swedish Massage',
  description: 'A gentle, relaxing full-body massage ideal for melting away tension and improving circulation.',
  duration: '60 / 90 min',
  price: 'From $85'
}, {
  icon: <Activity className="w-8 h-8" data-id="element-189" />,
  title: 'Deep Tissue',
  description: 'Focuses on the deepest layers of muscle tissue to release chronic tension and knots.',
  duration: '60 / 90 min',
  price: 'From $95'
}, {
  icon: <Flame className="w-8 h-8" data-id="element-190" />,
  title: 'Hot Stone',
  description: 'Smooth, heated stones are placed on specific parts of the body to warm and loosen tight muscles.',
  duration: '90 min',
  price: 'From $120'
}, {
  icon: <Droplets className="w-8 h-8" data-id="element-191" />,
  title: 'Aromatherapy',
  description: 'Combines soft, gentle pressure with the use of essential oils to promote healing and relaxation.',
  duration: '60 / 90 min',
  price: 'From $90'
}, {
  icon: <Dumbbell className="w-8 h-8" data-id="element-192" />,
  title: 'Sports Massage',
  description: 'Geared toward active individuals to help prevent injury, improve flexibility, and enhance performance.',
  duration: '60 min',
  price: 'From $100'
}, {
  icon: <Baby className="w-8 h-8" data-id="element-193" />,
  title: 'Prenatal Massage',
  description: 'A safe, gentle massage designed specifically to relieve the physical discomforts of pregnancy.',
  duration: '60 min',
  price: 'From $90'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Services() {
  return <section id="services" className="py-24 bg-[#111111]" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center mb-16" data-id="element-196">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl text-[#F5F0EB] mb-4" data-id="element-197">
            Our Services
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '80px'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="h-1 bg-[#D4AF37] mx-auto mb-6" data-id="element-198" />
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="text-[#999999] max-w-2xl mx-auto text-lg" data-id="element-199">
            Discover our range of therapeutic treatments designed to restore
            balance to your body and mind.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-200">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-[#1A1A1A] p-8 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-300 group border border-[#2A2A2A]" data-id="element-201">
              <div className="text-[#D4AF37] mb-6 group-hover:text-[#F0D060] transition-colors duration-300" data-id="element-202">
                {service.icon}
              </div>
              <h3 className="text-2xl text-[#F5F0EB] mb-3" data-id="element-203">{service.title}</h3>
              <p className="text-[#999999] mb-6 leading-relaxed" data-id="element-204">
                {service.description}
              </p>
              <div className="flex justify-between items-center pt-4 border-t border-[#2A2A2A]" data-id="element-205">
                <span className="text-sm font-medium text-[#D4AF37] uppercase tracking-wider" data-id="element-206">
                  {service.duration}
                </span>
                <span className="text-lg font-semibold text-[#F5F0EB]" data-id="element-207">
                  {service.price}
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}